<template>
  <VpKebabMenu size="16px" :menu-options="_options" menu-position="down-left" open-by="click" @click="activate" />
</template>

<script>
import VpKebabMenu from '../vp-kebab-menu/VpKebabMenu.vue';

export default {
  name: 'VpTableAction',
  components: {
    VpKebabMenu,
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    _options() {
      return this.options.map((option) => {
        let { isDisabled = false, hoverTitle = null } = option;
        if (typeof isDisabled === 'function') isDisabled = isDisabled(this.item);
        if (typeof hoverTitle === 'function') hoverTitle = hoverTitle(this.item);

        return { ...option, isDisabled, hoverTitle };
      });
    },
  },
  methods: {
    activate(option) {
      return option.onClick(option.value, this.item);
    },
  },
};
</script>

<style>

</style>
